<template>
  <div class="main-box">
    <div class="main-header">
      <div class="rest_back" @click="goBack"></div>
      <div class="rest_title">管片年度生产</div>
    </div>
    <div class="main-container-box">
      <div class="header-box">
        <div class="rest_card_text">
          生效时间
          <span :class="{ effect: isEffect }">{{ isEffect ? '(已生效)' : '(未生效)' }}</span>
        </div>
        <div class="rest_time" style="margin-top: 10px">
          <el-date-picker
            v-model="query.startTime"
            type="datetime"
            style="width: 100%"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间">
          </el-date-picker>
        </div>
        <div class="rest_time">
          <el-date-picker
            v-model="query.endTime"
            type="datetime"
            style="width: 100%"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间">
          </el-date-picker>
        </div>
      </div>
      <div class="content-box">
        <div class="content-list-wrap" v-for="(item, index) in dataList" :key="index">
          <div class="content-list-header">
            <div class="list-header_text">项目名称</div>
            <div class="list-header_data">
              {{ item.proName }}
            </div>
          </div>
          <div class="content-list-item">
            <div class="item_text">应完成总量(环)</div>
            <div class="item_datas">
              <el-input
                type="number"
                v-model="item.planProduct"
                placeholder="请输入应用完成总量"></el-input>
            </div>
          </div>
          <div class="content-list-item">
            <div class="item_text">已完成环数</div>
            <div class="item_datas">
              <el-input
                type="number"
                v-model="item.ringCount"
                placeholder="请输入已完成环数"></el-input>
            </div>
          </div>
          <div class="content-list-item">
            <div class="item_text">完成进度%</div>
            <div class="item_datas">
              <el-input
                type="number"
                v-model="item.completeRate"
                placeholder="请输入完成进度"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-box">
        <el-button class="btn" size="big" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { throttle } from '../../plugins/public' // 导入节流、动态切换组件尺寸方法
export default {
  data() {
    return {
      isEffect: false,
      query: {
        startTime: '',
        endTime: ''
      },
      dataList: []
    }
  },
  beforeCreate() {
    this.menuId = this.$route.query.menuId
    this.$http = this.$api.screenCms.PieceProduct
  },
  created() {
    this.getLists()
  },
  methods: {
    //获取列表
    getLists() {
      this.$http.getLists({ menuId: this.menuId }).then(res => {
        if (res.statusMsg !== 'ok') return this.$message.warning(res.statusMsg)
        let { startTime, endTime, ndscList = [] } = res.data
        Object.assign(this.query, {
          startTime,
          endTime
        })
        this.dataList = ndscList
        this.checkoutEffect()
      })
    },
    // 添加数据
    addRow() {
      let params = {
        ...this.query,
        menuId: this.menuId,
        ndscList: [...this.dataList]
      }
      this.$http.addRow(params).then(res => {
        if (res.statusMsg === 'ok') {
          this.$message.success('提交成功')
          this.getLists()
        } else {
          this.$message.warning(res.statusMsg)
        }
      })
    },
    // 验证: 已完成 <= 总量 和 生效时间(结束 > 开始)
    validate() {
      let validated = true
      let { startTime, endTime } = this.query

      if (!startTime || !endTime) {
        this.$message.warning('生效时间未填')
        return
      }
      if (startTime && endTime && +new Date(startTime) >= +new Date(endTime)) {
        this.$message.warning('结束时间 必须大于 开始时间')
        return
      }

      for (let index = 0; index < this.dataList.length; index++) {
        const val = this.dataList[index]
        if (val.planProduct && val.ringCount && +val.ringCount > +val.planProduct) {
          this.$message.warning('已完成环数 必须小于或等于 应完成总量')
          validated = false
          break
        }
      }
      return validated
    },
    // 节流提交
    throttleSubmit: throttle(function () {
      this.addRow()
    }, 3000),
    // 提交表单
    onSubmit() {
      if (this.validate()) {
        this.throttleSubmit()
      }
    },
    // 是否生效
    checkoutEffect() {
      let { startTime, endTime } = this.query
      if (startTime && endTime) {
        if (+new Date(startTime) <= +new Date() && +new Date() < +new Date(endTime)) {
          this.isEffect = true
          return
        }
      }
      this.isEffect = false
    },
    //返回首页
    goBack() {
      this.$router.back()
    }
  }
}
</script>
<style scoped lang="scss">
/* 滚动条统一样式修改 */
/deep/ {
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px transparent;
    background: #39b5fe;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
    background: rgba(76, 188, 254, 0.3);
  }
}
.main-box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f6f8fe;
  background-image: url('../../assets/opration/rest_bgh.png');
  background-repeat: no-repeat;
  background-size: 100% auto;

  .main-header {
    width: 100%;
    height: 76px;
    position: relative;
    .rest_back {
      position: absolute;
      top: 18px;
      left: 10px;
      width: 30px;
      height: 30px;
      background: url('../../assets/opration/rest_back.png') center no-repeat;
      background-size: 9px 16px;
    }
    .rest_title {
      font-size: 17px;
      font-weight: 600;
      letter-spacing: 3px;
      color: rgba(255, 255, 255, 0.92);
      position: absolute;
      top: 25px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .main-container-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    top: 76px;
    bottom: 0px;
    padding: 0 15px;

    .header-box {
      width: 100%;
      height: 141px;
      border-radius: 8px;
      background: #ffffff;
      padding: 15px;
      box-shadow: 0px 20px 48px 9px rgba(0, 0, 0, 0.05);

      .rest_card_text {
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
        font-weight: bold;
        > span {
          font-size: 14px;
          color: red;
          &.effect {
            color: #00d154;
          }
        }
      }
      .rest_time {
        padding: 5px;
      }
    }

    .content-box {
      overflow: auto;
      flex: 1;
      margin-bottom: 10px;
      box-shadow: 0px 20px 48px 9px rgba(0, 0, 0, 0.05);
      .content-list-wrap {
        width: 100%;
        border-radius: 8px;
        margin-top: 12px;
        background: #ffffff;
        padding: 15px;

        .content-list-header {
          width: 100%;
          background: rgba(225, 237, 255, 1);
          display: flex;
          justify-content: space-between;
          padding: 10px 15px;
          align-items: center;
          border-radius: 5px;
          .list-header_text {
            margin-right: 10px;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-weight: bold;
            white-space: nowrap;
          }
          .list-header_data {
            color: rgba(35, 126, 255, 1);
            font-size: 16px;
            font-weight: bold;
          }
        }

        .content-list-item {
          padding: 10px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(225, 237, 255, 1);
          .item_text {
            color: rgba(49, 51, 64, 1);
            font-size: 16px;
            font-weight: 400;
            margin-right: 10px;
          }
          .item_datas {
            overflow: hidden;
            flex: 1;
          }
          /deep/.item_datas .el-input__inner {
            color: #237eff;
            border: 0;
            text-align: right;
          }
          /deep/.item_datas .el-input__inner::placeholder {
            position: absolute;
            top: 8px;
            right: 16px;
          }
        }
      }
    }

    .footer-box {
      margin-bottom: 12px;
      box-shadow: 0px 20px 48px 9px rgba(0, 0, 0, 0.05);
      .btn {
        width: 100%;
        font-size: 18px;
      }
    }
  }
}

@media only screen and (min-width: 600px) {
  .main-box {
    position: absolute;
    width: 600px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
